import React from 'react';
import { Icon } from 'antd';
import { FormField, isStepValid, Request } from 'utils/registration/formUtils';
import FA from 'actions/fsdo/fsdoFsdoActions';

const init = {
    status: 'invalid',
    fsdoRequest: new Request(),
    fsdoLoaded: false,
    fsdoLocations: null,
    fsdoSubmission: {
        request: new Request(),
        modal: {
            content: null,
            props: {
                visible: false
            }
        }
    },
    submissionModalContent: null,
    showSubmitView: false,
    submitStep: 0
};

export default (state=init, action) => {
    switch(action.type) {
        case FA.UPDATE_FSDO_STATE_OPTIONS:
            return ((s, p, o) => ({...s, forms: {...s.forms, [p]: {...s.forms[p], options: o }}}))
            (state, action.payload.formProp, action.payload.options)

        case FA.GET_FSDO_LOCATIONS_PENDING:
            return {...state, fsdoRequest: {...state.fsdoRequest, status: 'pending' } };

        case FA.GET_FSDO_LOCATIONS_SUCCESS:
            return ((s, d) => {
                let
                result = [],
                set = new Set(d.map((e) => (e.name))),
                array = [...set];

                array.sort();
                for(let i=0; i < array.length; i++) {
                    for(let j=0; j < d.length; j++) {
                        if(array[i] === d[j].name) {
                            result.push(d[j]);
                            break;
                        }
                    }
                }

                return {...state,
                    fsdoLoaded: true,
                    fsdoLocations: result,
                    fsdoRequest: {...state.fsdoRequest,
                        status: 'success'
                    }
                };
            })(state, action.payload)

        case FA.GET_FSDO_LOCATIONS_FAILURE:
            return {...state, fsdoRequest: {...state.fsdoRequest, status: 'failure' } };

        case FA.RESET_FSDO_LOAD_REQUEST:
            return {...state, fsdoRequest: new Request() };

        case FA.FSDO_TOGGLE_SUBMISSION_MODAL:
            return {...state, fsdoSubmission: {...state.fsdoSubmission, modal: {...state.fsdoSubmission.modal,
                props: {...state.fsdoSubmission.modal.props,
                    visible: !state.fsdoSubmission.modal.props.visible
                }
            }}};

        case FA.FSDO_UPDATE_MODAL_CONTENT:
            return {...state, fsdoSubmission: {...state.fsdoSubmission, modal: {...state.fsdoSubmission.modal,
                content: action.payload
            }}};

        case FA.FSDO_UPDATE_MODAL_PROPS:
            return {...state, fsdoSubmission: {...state.fsdoSubmission, modal: {...state.fsdoSubmission.modal,
                props: action.payload
            }}};

        case FA.FSDO_SUBMISSION_PENDING:
            return {...state,
                fsdoSubmission: {...state.fsdoSubmission,
                    request: {...state.fsdoSubmission.request,
                        status: 'pending'
                    }
                }
            };

        case FA.FSDO_SUBMISSION_SUCCESS:
            return {...state,
                fsdoSubmission: {...state.fsdoSubmission,
                    request: {...state.fsdoSubmission.request,
                        status: 'success'
                    }
                }
            };

        case FA.FSDO_SUBMISSION_FAILURE:
            return {...state,
                fsdoSubmission: {...state.fsdoSubmission,
                    request: {...state.fsdoSubmission.request,
                        status: 'failure',
                        code: action.payload.status
                    }
                }
            };

        case FA.FSDO_RESET_SUBMISSION_REQUEST:
            return {...state,
                fsdoSubmission: {...state.fsdoSubmission,
                    request: new Request()
                }
            }

        case FA.FSDO_TOGGLE_SUBMIT_VIEW:
            return {...state, showSubmitView: !state.showSubmitView };

        case FA.FSDO_CHANGE_VALIDATION_STEP:
            return {...state, submitStep: action.payload };

        case FA.FSDO_RESET_SUBMISSION:
            return {...init};

        default: return {...state};
    }
}
